@if (orderReturnListResult$ | async; as orderReturnListResult) {
  <div class="results-section" role="region" aria-labelledby="return-results-heading"
    >
    @if (sorts$ | async; as sorts) {
      <div class="results-header">
        @if (paginate$ | async; as paginate) {
          <kn-br-browsing [paginate]="paginate" [recordsShown]="orderReturnListResult.length"
            recordType="{{ 'label.returnorder' | cxTranslate }}">
          </kn-br-browsing>
        }
        <div class="results-actions">
          <label class="sort-label" for="return-sort-select">
            Sort By
          </label>
          <cx-sorting  id="return-sort-select" class="sort-select"
            [sortOptions]="sorts"
            [sortLabels]="getSortLabels() | async"
            (sortListEvent)="changeSortCode($event)"
            [selectedOption]="sortType"
            container="body"
            >
          </cx-sorting>
          <button type="button" [disabled]="downloadProgress" class="download-btn"
            (click)="downloadReturns('orderReturns', 'Returns', true, 'Return_Export')">
            {{ 'invoiceResult.download' | cxTranslate }}
            <i class="fas fa-download" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    }
    @if (orderReturnListResult && orderReturnListResult.length) {
      <div role="region" aria-label="Returns table" tabindex="0"
        >
        <table class="returns-table" role="table" aria-label="Return orders data">
          <thead>
            <tr role="row">
              <th role="columnheader" scope="col">{{ 'orderReturnResult.header.rma' | cxTranslate }}</th>
              <th role="columnheader" scope="col">{{ 'orderHistoryResult.header.accountNumber' | cxTranslate }}</th>
              <th role="columnheader" scope="col">{{ 'orderHistoryResult.header.accountName' | cxTranslate }}</th>
              <th role="columnheader" scope="col">{{ 'orderReturnResult.header.createdOn' | cxTranslate }}</th>
              <th role="columnheader" scope="col">{{ 'orderHistoryResult.header.purchaseOrderNumber' | cxTranslate }}</th>
              <th role="columnheader" scope="col">{{ 'orderReturnResult.header.status' | cxTranslate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (order of orderReturnListResult; track order) {
              <tr role="row" (click)="redirectToDetail(order)">
                <td role="gridcell" [attr.data-label]="'orderReturnResult.header.rma' | cxTranslate">
                  <a href="javascript:void(0)" class="rma-link">{{ order.rma | removeLeadingZeros }}</a>
                </td>
                <td role="gridcell" [attr.data-label]="'orderHistoryResult.header.accountNumber' | cxTranslate">
                  {{ order.accountNumber | removeLeadingZeros }}
                </td>
                <td role="gridcell" [attr.data-label]="'orderHistoryResult.header.accountName' | cxTranslate">
                  {{ order.accountName }}
                </td>
                <td role="gridcell" [attr.data-label]="'orderReturnResult.header.createdOn' | cxTranslate">
                  {{ order.returnRequestDate }}
                </td>
                <td role="gridcell" [attr.data-label]="'orderHistoryResult.header.purchaseOrderNumber' | cxTranslate">
                  {{ order.purchaseOrderNumber ? order.purchaseOrderNumber : '-' }}
                </td>
                <td role="gridcell" [attr.data-label]="'orderReturnResult.header.status' | cxTranslate">
                  {{ order.statusDisplay }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    @if (paginate$ | async; as paginate) {
      <div class="show-more-container">
        @if (paginate.currentPage < paginate.totalPages - 1 && (isLoader$ | async)===false) {
          <button class="show-more-btn"
            (click)="loadMore(paginate.currentPage)">
            {{ 'orderReturnResult.showMore' | cxTranslate }}
          </button>
        }
      </div>
    }
    @if (orderReturnListResult && orderReturnListResult.length < 1 && (isLoader$ | async)===false) {
      <div class="alert-info p-3 rounded mt-3"
        >
        {{ 'orderReturnResult.nodataMsg' | cxTranslate }}
      </div>
    }
  </div>
}
